import React from "react";
import AntdSkeleton from 'antd/lib/skeleton';
import {withError} from '@fishx/tracker';

const Skeleton = (props) => <AntdSkeleton {...props} />
Skeleton.displayName = 'Skeleton';
export default withError(Skeleton);



// WEBPACK FOOTER //
// ./src/components/skeleton/index.tsx